import { __assign, __rest } from "tslib";
import React, { useContext } from 'react';
import DaViewer from '../../DaEditor/components/Viewer/Viewer';
import { Image } from '../PluginComponents/Image';
import { Gallery } from '../PluginComponents/Gallery';
import { ThemeContext } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { DaEditorContext } from '../../Context/DaEditorContext';
var BaseViewer = function (_a) {
    var fixedParagraphFromProps = _a.fixedParagraph, restProps = __rest(_a, ["fixedParagraph"]);
    var isMobile = useContext(MobileContext);
    var contextTheme = useContext(ThemeContext);
    // Never fixed for mobile
    var fixedParagraph = isMobile ? false : fixedParagraphFromProps;
    return (React.createElement(DaEditorContext.Provider, { value: true },
        React.createElement(DaViewer, __assign({ imageComponent: Image, galleryComponent: Gallery, isDarkTheme: contextTheme === 'dark', fixedParagraph: fixedParagraph }, restProps))));
};
BaseViewer.displayName = 'BaseViewer';
export default BaseViewer;
//# sourceMappingURL=Base.js.map